import type { BasePath } from "../../types/routeTypes";
export default function getBasePathFromParams(params: {
  hostConfig: string;
  messengerId: string;
  tenantId: string;
  locale?: string;
}): BasePath {
  const appBasePath: BasePath = `/${params.tenantId}/${params.messengerId}/${params.hostConfig}`;
  return params.locale ? `${appBasePath}/${params.locale}` : appBasePath;
}
